import React from "react"

import Layout from "../components/allstar/layout"
import PageContent from "../components/allstar/resource/research-all-stars/section-hero"
import { graphql } from "gatsby"

const LandingPage = props => {
  return (
    <Layout
      location={props.location}
      title={"Healthcare Research All-Stars"}
      isResourceSite
    >
      <PageContent data={props.data} />
    </Layout>
  )
}

export default LandingPage

export const query = graphql`
  query landingPageQuery {
    allBadges: allFile(
      filter: { relativeDirectory: { eq: "allstar/badges" } }
    ) {
      edges {
        node {
          name
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`
